import { useEffect, useState } from 'react';

const keyCode = 'KeyK';

export const ShortcutDescription = 'Ctrl + K';

/**
 * Determines if a keyboard event is the global search hotkey: `Ctrl + K`.
 */
export const isSearchHotkey = (event: KeyboardEvent) =>
    (event.ctrlKey || event.metaKey) && event.code === keyCode;

/**
 * Hook to keep track of global search modal visibility:
 * * `Ctrl/Command + K` toggles visibility
 * * `Escape` sets not visible
 */
export function useGlobalSearchVisibility() {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const onKeyDown = (event: KeyboardEvent) => {
            if (isSearchHotkey(event)) {
                event.preventDefault();
                event.stopPropagation();
                setIsVisible((visible) => !visible);
            } else if (event.code === 'Escape' && isVisible) {
                setIsVisible(false);
            }
        };

        window.addEventListener('keydown', onKeyDown);
        return () => window.removeEventListener('keydown', onKeyDown);
    }, [isVisible]);

    return { isVisible, setIsVisible };
}
